import { FC } from 'react';
import styled from 'styled-components';
import { SYM } from '../../Components/MaterialSymbol';

const MenuStage = styled.div`
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  padding: 2em 1em;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    padding: 1.5em 0;
  }
`;
const ViewSelector = styled.div`
  width: min(100%, 44em);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25em;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const ViewCard = styled.article`
  min-height: 14em;
  margin: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const ViewCardHeader = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5em;
  font-size: 1.1em;
  font-weight: 700;
`;
const ViewCardDescription = styled.p`
  flex: 1 1 auto;
  margin: 0;
  line-height: 1.5;
`;
const ViewCardFooter = styled.footer`
  margin-top: auto;
`;
const ViewCardAction = styled.button`
  width: 100%;
  margin: 0;
`;

export type AdminMenuProps = {
  onSelectSearch: () => void;
  onSelectTools: () => void;
};

export const AdminMenu: FC<AdminMenuProps> = ({ onSelectSearch, onSelectTools }) => (
  <MenuStage>
    <ViewSelector aria-label="Employer admin views">
      <ViewCard>
        <ViewCardHeader>
          <SYM>group</SYM>
          Candidates
        </ViewCardHeader>
        <ViewCardDescription>
          View the candidates who signed up through your organization and track their interview progress.
        </ViewCardDescription>
        <ViewCardFooter>
          <ViewCardAction type="button" onClick={onSelectSearch}>
            View Candidates
          </ViewCardAction>
        </ViewCardFooter>
      </ViewCard>
      <ViewCard>
        <ViewCardHeader>
          <SYM>link</SYM>
          Sign-Up Tools
        </ViewCardHeader>
        <ViewCardDescription>
          Copy your organization code or create a position-specific sign-up link to share with candidates.
        </ViewCardDescription>
        <ViewCardFooter>
          <ViewCardAction type="button" onClick={onSelectTools}>
            Open Sign-Up Tools
          </ViewCardAction>
        </ViewCardFooter>
      </ViewCard>
    </ViewSelector>
  </MenuStage>
);
